/* NYGHT native drawers (2026-09-30): <nyght-menu> and <cart-drawer>. Replaces Dawn's header-drawer and Kaching Cart. */
(() => {
  const money = (cents) => new Intl.NumberFormat('da-DK', { maximumFractionDigits: 0 }).format(cents / 100) + ' kr.';
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const lock = (on) => document.documentElement.classList.toggle('nn-lock', on);

  class NyghtMenu extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.btn = this.querySelector('.nn-menu__open');
      // the header is a sticky stacking context; move the panel to <body> so nothing in the header can sit on top of it
      this.layer = document.createElement('div'); this.layer.className = 'nn-menu nn-layer';
      this.layer.append(this.querySelector('.nn-menu__overlay'), this.querySelector('.nn-menu__panel'));
      document.body.append(this.layer);
      this.btn.addEventListener('click', () => this.toggle(true));
      this.layer.querySelectorAll('[data-nn-close]').forEach((el) => el.addEventListener('click', () => this.toggle(false)));
      this.layer.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.toggle(false); });
    }
    toggle(open) {
      this.layer.classList.toggle('is-open', open); this.btn.setAttribute('aria-expanded', open); lock(open);
      if (open) this.layer.querySelector('.nn-menu__panel').focus(); else this.btn.focus();
    }
  }
  customElements.define('nyght-menu', NyghtMenu);

  class NyghtCart extends HTMLElement {
    connectedCallback() {
      if (this.parentElement !== document.body) { document.body.append(this); return; }  // escape the sticky header's stacking context
      if (this.ready) return; this.ready = true;
      this.items = this.querySelector('[data-nn-items]');
      try { this.ups = JSON.parse(this.querySelector('[data-nn-ups-data]')?.textContent || '[]'); } catch (_) { this.ups = []; }
      try { this.fitProduct = JSON.parse(this.querySelector('[data-nn-fit-data]')?.textContent || 'null'); } catch (_) { this.fitProduct = null; }
      try { this.bundles = JSON.parse(this.querySelector('[data-nn-bundle-data]')?.textContent || '{}'); } catch (_) { this.bundles = {}; }
      this.querySelectorAll('[data-nn-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('change', (e) => { if (e.target.matches('[data-nn-ups-variant]')) this.syncUpsPrice(e.target); });
      document.addEventListener('click', (e) => {
        const icon = e.target.closest && e.target.closest('#cart-icon-bubble');
        if (icon) { e.preventDefault(); this.open(); }
      });
      window.nyghtCart = this;
      this.refresh(false);
    }
    // --- Dawn product-form.js contract ---
    getSectionsToRender() { return []; }
    setActiveElement(el) { this.activeElement = el; }
    renderContents() { this.refresh(true); }
    // ---
    open() { this.classList.add('is-open'); this.setAttribute('aria-hidden', 'false'); lock(true); this.querySelector('.nn-cart__panel').focus(); }
    close() { this.classList.remove('is-open'); this.setAttribute('aria-hidden', 'true'); lock(false); this.activeElement?.focus?.(); }
    async refresh(openAfter) {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      this.render(cart);
      if (openAfter) this.open();
    }
    // Bedding bundles (2026-10-06) belong to a duvet: drop them when no duvet is left, and never more bundles than
    // the duvets allow (one-duvet bundle = 1 per duvet, two-duvet bundle = 1 per 2 duvets).
    async guardBundles(cart) {
      if (this.guarding) return false;
      const duvets = cart.items.filter((it) => it.handle === 'hybridduvet').reduce((n, it) => n + it.quantity, 0);
      let room = duvets, fix = null;
      cart.items.forEach((it, i) => {
        const bx = this.bundles[it.variant_id]; if (!bx || fix) return;
        const allowed = Math.floor(room / bx.per);
        if (it.quantity > allowed) fix = { line: i + 1, quantity: Math.max(0, allowed) };
        room -= Math.min(it.quantity, allowed) * bx.per;
      });
      if (!fix) return false;
      this.guarding = true;
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(fix) });
      this.guarding = false;
      this.bundleNote = 'Sengetøjet til tilbudspris følger med en Hybridduvet – det er justeret i kurven.';
      await this.refresh(false);
      return true;
    }
    render(cart) {
      if (Object.keys(this.bundles || {}).length && cart.items.some((it) => this.bundles[it.variant_id])) {
        this.guardBundles(cart).then((fixed) => { if (fixed) return; });
      }
      const bundleSave = cart.items.reduce((n, it) => { const bx = (this.bundles || {})[it.variant_id]; return n + (bx ? Math.max(0, bx.value * it.quantity - it.final_line_price) : 0); }, 0);
      this.classList.toggle('is-empty', cart.item_count === 0);
      this.querySelector('[data-nn-count]').textContent = cart.item_count ? `· ${cart.item_count}` : '';
      // before prices (compare-at) count as savings too (2026-10-12)
      if (!this.cmp) { try { this.cmp = JSON.parse((this.querySelector('[data-nn-cmp-data]') || {}).textContent || '{}'); } catch (e) { this.cmp = {}; } }
      const wasLine = (it) => Math.max(it.original_line_price, (this.cmp[it.variant_id] || 0) * it.quantity);
      const cmpSave = cart.items.reduce((n, it) => n + ((this.bundles || {})[it.variant_id] ? 0 : wasLine(it) - it.original_line_price), 0);
      const saved = cart.total_discount + bundleSave + cmpSave;
      this.querySelector('[data-nn-total]').innerHTML = (saved > 0 ? `<s>${money(cart.original_total_price + bundleSave + cmpSave)}</s> ` : '') + money(cart.total_price);
      // --- free delivery from 1.000 kr. (2026-10-09) ---
      const ship = this.querySelector('[data-nn-ship]');
      if (ship) {
        const left = +ship.dataset.threshold - cart.total_price;
        ship.classList.toggle('is-free', left <= 0);
        ship.querySelector('[data-nn-ship-t]').innerHTML = left <= 0 ? '<b>Gratis levering</b> til pakkeshop · næste hverdag' : `Køb for <b>${money(left)}</b> mere, så er leveringen gratis`;
        ship.querySelector('[data-nn-ship-bar]').style.width = Math.min(100, Math.round(cart.total_price / +ship.dataset.threshold * 100)) + '%';
      }
      // --- savings + free gift (2026-10-02, owner: "make savings much bigger, free gift more tydelig") ---
      const gifts = cart.items.filter((it) => it.final_line_price === 0 && it.original_line_price > 0);
      const giftQty = gifts.reduce((n, it) => n + it.quantity, 0);
      const giftValue = gifts.reduce((n, it) => n + it.original_line_price, 0);
      // campaign gift (2026-10-11): pillow (one variant) or a duvet cover in the duvet's size (gift map size → variant)
      let gmap = null; try { gmap = JSON.parse(this.dataset.giftMap || 'null'); } catch (e) {}
      const isDuvet = (it) => gmap ? it.handle === 'hybridduvet' : /hybridduvet/i.test(it.handle || '');
      const duvetQty = cart.items.filter(isDuvet).reduce((n, it) => n + it.quantity, 0);
      const live = this.dataset.giftVariant && Date.now() < Date.parse(this.dataset.offerEnds || 0);
      let missing = live ? Math.max(0, duvetQty - giftQty) : 0, giftAdd = this.dataset.giftVariant;
      if (live && gmap) {
        const need = {}, have = {};
        cart.items.filter(isDuvet).forEach((it) => { const sz = (it.variant_options || [])[0]; need[sz] = (need[sz] || 0) + it.quantity; });
        gifts.forEach((it) => { const sz = (it.variant_options || []).slice(-1)[0]; have[sz] = (have[sz] || 0) + it.quantity; });
        const lack = Object.keys(need).find((sz) => (need[sz] - (have[sz] || 0)) > 0 && gmap[sz]);
        missing = lack ? need[lack] - (have[lack] || 0) : 0; giftAdd = lack ? gmap[lack] : '';
      }
      const gShort = this.dataset.giftShort || 'pude', gName = this.dataset.giftName || 'Hybridpillow';
      const byTitle = {};
      cart.items.forEach((it) => (it.line_level_discount_allocations || []).forEach((a) => { if (a.amount > 0) byTitle[a.discount_application.title] = (byTitle[a.discount_application.title] || 0) + a.amount; }));
      (cart.cart_level_discount_applications || []).forEach((d) => { byTitle[d.title] = (byTitle[d.title] || 0) + d.total_allocated_amount; });
      const save = this.querySelector('[data-nn-save]');
      if (save) {
        save.hidden = !(saved > 0);
        const what = [giftQty ? `${giftQty} gratis ${gShort === 'pude' && giftQty > 1 ? 'puder' : gShort}` : '', byTitle['Pakken til to'] ? 'pakkepris' : '', bundleSave ? 'sengetøj' : ''].filter(Boolean).join(' + ');
        const ends = this.dataset.offerEnds && Date.now() < Date.parse(this.dataset.offerEnds) ? this.dataset.offerEnds : '';
        save.innerHTML = saved > 0 ? `<span class="nn-save__l">Du sparer <b>${money(saved)}</b></span>${ends ? `<span class="nn-save__r">${esc(this.dataset.endsLabel || '')}</span>` : (what ? `<span class="nn-save__r">${esc(what)}</span>` : '')}` : '';
      }
      const deals = this.querySelector('[data-nn-deals]');
      if (deals) deals.innerHTML = '';
      const giftBar = giftQty
        ? ''
        : missing
          ? `<div class="nn-gift-bar nn-gift-bar--cta"><span class="nn-gift-bar__icon">🎁</span><span><b>Du har ${missing} gratis ${esc(gName)} til gode</b><small>Følger med din Hybridduvet</small></span><button type="button" data-add="${giftAdd}" data-n="${missing}">Tilføj gratis</button></div>`
          : '';
      const note = this.bundleNote ? `<p class="nn-line__note">${esc(this.bundleNote)}</p>` : ''; this.bundleNote = '';
      this.items.innerHTML = note + giftBar + cart.items.map((it, i) => (this.bundles || {})[it.variant_id] ? this.bundleLine(it, i) : `
        <div class="nn-line${it.final_line_price === 0 && it.original_line_price > 0 ? ' nn-line--gift' : ''}" data-line="${i + 1}">
          <a href="${esc(it.url)}" class="nn-line__img">${it.image ? `<img src="${esc(it.image)}&width=200" alt="" loading="lazy">` : ''}</a>
          <div class="nn-line__body">
            <div class="nn-line__head"><a href="${esc(it.url)}"><b>${esc(it.product_title)}</b></a><span class="nn-line__price">${it.final_line_price < wasLine(it) ? `<s>${money(wasLine(it))}</s>` : ''}<b>${it.final_line_price === 0 ? 'GRATIS' : money(it.final_line_price)}</b></span></div>
            ${it.final_line_price === 0 && it.original_line_price > 0 ? '<p class="nn-line__deal nn-line__deal--gift">🎁 Gratis gave</p>' : (it.line_level_discount_allocations || []).filter((a) => a.amount > 0).map((a) => `<p class="nn-line__deal">${esc(a.discount_application.title)}</p>`).join('')}
            ${it.variant_title ? `<p class="nn-line__var">${esc(it.variant_title)}</p>` : ''}
            <div class="nn-line__row">
              <div class="nn-qty"><button type="button" data-qty="${it.quantity - 1}" aria-label="Færre">−</button><span>${it.quantity}</span><button type="button" data-qty="${it.quantity + 1}" aria-label="Flere">+</button></div>
              <button type="button" class="nn-line__rm" data-qty="0">Fjern</button>
            </div>
          </div>
        </div>`).join('');
      const inCart = new Set(cart.items.map((it) => it.product_id));
      // "Passer til din dyne" (2026-10-05, RPV): with a Hybridduvet in the cart, lead with the bambus duvet cover in
      // the duvet's own size, one per duvet, added in one tap.
      const set = this.fitProduct;
      let fit = null;
      const hasBundle = cart.items.some((it) => /^sengetoj-(til|komplet)-/.test(it.handle || ''));
      if (set && !inCart.has(set.id) && !hasBundle) {
        const bySize = {};
        cart.items.filter((it) => it.handle === 'hybridduvet' && it.final_line_price > 0).forEach((it) => {
          const size = ((it.variant_title || '').match(/140x2[02]0/) || [])[0];
          if (size) bySize[size] = (bySize[size] || 0) + it.quantity;
        });
        const items = Object.entries(bySize).map(([size, qty]) => {
          const v = set.variants.find((x) => x.available && x.title.includes(size));
          return v && { id: v.id, quantity: qty, size, price: v.price };
        }).filter(Boolean);
        if (items.length) fit = { items, qty: items.reduce((n, x) => n + x.quantity, 0), total: items.reduce((n, x) => n + x.price * x.quantity, 0) };
      }
      const ups = this.ups.filter((p) => !inCart.has(p.id) && !(fit && p.id === set.id) && p.variants.some((v) => v.available)).slice(0, fit ? 2 : 3);
      const wrap = this.querySelector('[data-nn-ups-wrap]');
      if (wrap) {
        wrap.hidden = ups.length === 0 || cart.item_count === 0;
        const sizes = fit ? [...new Set(fit.items.map((x) => x.size.replace('x', '×')))].join(' + ') : '';
        // The fit card lives in the fixed footer (above the total) so it stays visible however long the cart is.
        const fitBox = this.querySelector('[data-nn-fit]');
        if (fitBox) fitBox.innerHTML = fit ? `<div class="nn-up nn-up--fit">
            <span class="nn-up__img"><img src="${esc(set.image)}" alt="" loading="lazy"></span>
            <div class="nn-up__body"><em class="nn-up__tag">Passer til din dyne</em><b>${esc(set.title)}${fit.qty > 1 ? ` × ${fit.qty}` : ''}</b><span>${esc(sizes)} cm · <span class="nn-up__price">${money(fit.total)}</span></span></div>
            <button type="button" class="nn-up__add nn-up__add--wide" data-add-items='${JSON.stringify(fit.items.map(({ id, quantity }) => ({ id, quantity })))}' aria-label="Læg ${esc(set.title)} i kurven">Tilføj</button>
          </div>` : '';
        this.querySelector('[data-nn-ups]').innerHTML = ups.map((p) => {
          const vs = p.variants.filter((v) => v.available);
          return `<div class="nn-up">
            <a href="${esc(p.url)}" class="nn-up__img"><img src="${esc(p.image)}" alt="" loading="lazy"></a>
            <div class="nn-up__body"><b>${esc(p.title)}</b>${/bambus/i.test(p.title) && this.dataset.campaign === 'pude' && this.dataset.offerEnds && Date.now() < Date.parse(this.dataset.offerEnds) ? '<em class="nn-up__deal">Køb 2, få 1 gratis</em>' : ''}<span data-nn-ups-price>${money(vs[0].price)}</span>
              ${vs.length > 1 ? `<select data-nn-ups-variant aria-label="Vælg variant">${vs.map((v) => `<option value="${v.id}" data-price="${v.price}">${esc(v.title)}</option>`).join('')}</select>` : ''}
            </div>
            <button type="button" class="nn-up__add" data-add="${vs[0].id}" aria-label="Læg ${esc(p.title)} i kurven">+</button>
          </div>`;
        }).join('');
      }
      document.querySelectorAll('#cart-icon-bubble').forEach((icon) => {
        let bubble = icon.querySelector('.cart-count-bubble');
        if (!cart.item_count) { bubble?.remove(); return; }
        if (!bubble) { bubble = document.createElement('div'); bubble.className = 'cart-count-bubble'; bubble.innerHTML = '<span aria-hidden="true"></span>'; icon.append(bubble); }
        const n = bubble.querySelector('span[aria-hidden]') || bubble; n.textContent = cart.item_count;
      });
    }
    bundleLine(it, i) {
      const bx = this.bundles[it.variant_id], value = bx.value * it.quantity;
      return `
        <div class="nn-line nn-line--bundle" data-line="${i + 1}">
          <span class="nn-line__img">${it.image ? `<img src="${esc(it.image)}&width=200" alt="" loading="lazy">` : ''}</span>
          <div class="nn-line__body">
            <div class="nn-line__head"><b>${esc(it.product_title)}${it.quantity > 1 ? ` × ${it.quantity}` : ''}</b><span class="nn-line__price">${value > it.final_line_price ? `<s>${money(value)}</s>` : ''}<b>${money(it.final_line_price)}</b></span></div>
            ${value > it.final_line_price ? `<p class="nn-line__deal">Spar ${money(value - it.final_line_price)} · med din dyne</p>` : ''}
            <p class="nn-line__var">${esc(bx.items)}</p>
            <div class="nn-line__row"><span></span><button type="button" class="nn-line__rm" data-qty="0">Fjern</button></div>
          </div>
        </div>`;
    }
    syncUpsPrice(sel) {
      const card = sel.closest('.nn-up'); const opt = sel.selectedOptions[0];
      card.querySelector('[data-nn-ups-price]').textContent = money(+opt.dataset.price);
      card.querySelector('[data-add]').dataset.add = sel.value;
    }
    async onClick(e) {
      const q = e.target.closest('[data-qty]'); const add = e.target.closest('[data-add]'); const many = e.target.closest('[data-add-items]');
      if (q) {
        const line = +q.closest('.nn-line').dataset.line;
        this.classList.add('is-busy');
        const cart = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity: Math.max(0, +q.dataset.qty) }) }).then((r) => r.json());
        this.classList.remove('is-busy'); this.render(cart);
      } else if (many) {
        this.classList.add('is-busy');
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: JSON.parse(many.dataset.addItems) }) });
        this.classList.remove('is-busy'); this.refresh(false);
      } else if (add) {
        this.classList.add('is-busy');
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +add.dataset.add, quantity: +(add.dataset.n || 1) }] }) });
        this.classList.remove('is-busy'); this.refresh(false);
      }
    }
  }
  customElements.define('cart-drawer', NyghtCart);

  // Countdown + auto-expiry for the "Sidste parti" offer (2026-10-02). [data-nn-cd="ISO"] shows the time left
  // (data-style="boxes" for day/hour/min/sec boxes); [data-nn-until="ISO"] is hidden once that moment has passed.
  const pad = (n) => String(n).padStart(2, '0');
  const farLabel = (el, far) => {
    el.dataset.nnFar = far ? '1' : '0';
    el.hidden = far;
    const dp = new Intl.DateTimeFormat('da-DK', { timeZone: 'Europe/Copenhagen', day: 'numeric', month: 'numeric' }).formatToParts(new Date(Date.parse(el.dataset.nnCd))), date = `${dp.find(x => x.type === 'day').value}/${dp.find(x => x.type === 'month').value}`; // Danish date whatever the viewer's timezone (Cyprus showed 1/12 for 30/11 23:59)
    // the label is the nearest text before the timer inside its wrapper (same parent or the previous sibling's text)
    const box = el.parentElement && el.parentElement.closest('[data-nn-until], .nn-ann__item, small, p, span') || el.parentElement;
    if (!box) return;
    const walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT);
    let node, hit = null;
    while ((node = walker.nextNode())) {
      if (node.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING && /slutter om/i.test(node.nodeValue)) hit = node;
    }
    if (!hit) return;
    if (far) {
      hit.nnOrig = hit.nnOrig || hit.nodeValue;
      const hasDate = hit.parentElement && hit.parentElement.nextElementSibling && /\d+\/\d+/.test(hit.parentElement.nextElementSibling.textContent);
      hit.nodeValue = hit.nnOrig.replace(/(S|s)lutter om\s*$/, (m, c) => (c === 'S' ? 'G' : 'g') + 'ælder til og med' + (hasDate ? '' : ` ${date}`))
        .replace(/(S|s)lutter om(?=\S|\s+\S)/, (m, c) => (c === 'S' ? 'G' : 'g') + 'ælder til og med');
    } else if (hit.nnOrig) {
      hit.nodeValue = hit.nnOrig;
    }
  };
  const tick = () => {
    const now = Date.now();
    document.querySelectorAll('[data-nn-until]').forEach((el) => { if (now >= Date.parse(el.dataset.nnUntil)) el.hidden = true; });
    document.querySelectorAll('[data-nn-cd]').forEach((el) => {
      const left = Math.max(0, Math.floor((Date.parse(el.dataset.nnCd) - now) / 1000));
      // 2026-10-12 owner: "remove countdown timer if theres more than 10 days" — far away, the timer is hidden and the
      // "slutter om" label before it becomes "gælder til og med 30/11"; the live countdown returns for the last 10 days.
      const far = left > 10 * 86400;
      if (far !== (el.dataset.nnFar === '1')) farLabel(el, far);
      if (far) return;
      const d = Math.floor(left / 86400), h = Math.floor((left % 86400) / 3600), m = Math.floor((left % 3600) / 60), sec = left % 60;
      if (el.dataset.style === 'boxes') {
        el.innerHTML = [[d, d === 1 ? 'dag' : 'dage'], [h, 'timer'], [m, 'min'], [sec, 'sek']].map(([v, l]) => `<span><b>${pad(v)}</b><small>${l}</small></span>`).join('');
      } else {
        el.textContent = (d ? `${d}d ` : '') + `${pad(h)}:${pad(m)}:${pad(sec)}`;
      }
    });
  };
  tick(); setInterval(tick, 1000);

  // Videos below the fold load and play only when they scroll into view (2026-10-02 speed pass: ~9 MB of video
  // used to download on page load). Muted autoplay loops; paused again when out of view.
  const lazyVids = document.querySelectorAll('video.nn-lazyvid');
  if (lazyVids.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach(({ target: v, isIntersecting }) => {
      if (isIntersecting) { v.muted = true; v.preload = 'auto'; v.play().catch(() => {}); } else if (!v.paused) { v.pause(); }
    }), { rootMargin: '200px 0px' });
    lazyVids.forEach((v) => io.observe(v));
  }
})();
